var themeOptions = function () { return ({
    components: {
        MuiFormControlLabel: {
            styleOverrides: {
                root: {
                    marginLeft: 0,
                    gap: '8px',
                    '&.MuiFormControlLabel-labelPlacementStart': {
                        marginRight: 0,
                    },
                    '& .MuiFormControlLabel-label': {
                        marginTop: '0.6px',
                    },
                },
            },
            variants: [
                {
                    props: { 'data-multiline': 'multiline' },
                    style: {
                        alignItems: 'flex-start',
                        '& .MuiFormControlLabel-label': {
                            '--line-height': '1.25',
                            '&[class*="paragraph"]': {
                                '--line-height': '1.5',
                            },
                            lineHeight: 'var(--line-height)',
                            marginTop: 'calc(-0.525* 1em* var(--line-height) + 17.4px);',
                        },
                    },
                },
            ],
        },
    },
}); };
export default themeOptions;
//# sourceMappingURL=formControlLabelTheme.js.map